import React from "react";

const DemoPage: React.FC = () => {
  return (
    <iframe
      src="https://admin.hotsupper.top/#/"
      style={{ width: "100%", height: "100vh", border: "none" }}
      title="Demo"
    />
  );
};

export default DemoPage;
